module.exports = __webpack_public_path__ + "media/audio66.3bfaa175.mp3";